import { CurrentState } from "../../state/currentState";

// 단기 배출 예측 결과
export interface ShortTermDropEstimate {
  remainingTime: number;
  predictedDropBT: number;
}

/**
 * 현재 손실 추세를 직선 외삽하여
 * 목표 손실 도달 시점과 온도 예측
 */
export function extrapolateDropTime(
  state: CurrentState,
  currentLoss: number,
  lossSlope: number,
  targetLoss: number
): ShortTermDropEstimate {
  if (lossSlope <= 0) {
    return {
      remainingTime: Infinity,
      predictedDropBT: NaN,
    };
  }

  const deltaLoss = targetLoss - currentLoss;
  if (deltaLoss <= 0) {
    return {
      remainingTime: 0,
      predictedDropBT: state.BT,
    };
  }

  const remainingTime = Math.min(deltaLoss / lossSlope, 120);
  const predictedDropBT = state.BT + state.ROR * remainingTime;

  return { remainingTime, predictedDropBT };
}
